import React from "react"

import Tags from "./tags/Tags"
import TagItem from "./tags/TagItem"
import ContentLoaderTags from "./content-loading/ContentLoaderTags"

const RelatedInsightAreasViewWidget = ({
    primaryTopic,
    relatedTopics,
    isFetching
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />Insight areas
        </h3>
        <div className="widget-content">
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={3}
            >
                <Tags>
                    {primaryTopic && <TagItem>{primaryTopic.name}</TagItem>}
                    {(relatedTopics || []).map(({ id, name }) => (
                        <TagItem key={id} isGrey={true}>
                            {name}
                        </TagItem>
                    ))}
                </Tags>
                {!primaryTopic &&
                relatedTopics.length <= 0 && <p>No insight areas</p>}
            </ContentLoaderTags>
        </div>
    </div>
)

export default RelatedInsightAreasViewWidget
